import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { apiGateway, queryClient, useDoctorContext } from "../context";
import type { Patient } from "../interfaces";

interface EditPatientPayload {
  patientUuid: string;
  updates: Patient;
}

export const useEditPatient = (prevRoute: string, requestId: string) => {
  const navigate = useNavigate();
  const doctor = useDoctorContext();

  const editPatientFn = (editPatientPayload: EditPatientPayload) => {
    const raw = editPatientPayload.updates;

    const patient = {
      ...raw,
      rut: raw.rut ?? null,
      passport: raw.passport ?? null,
      weight: raw.weight === undefined || raw.weight === "" ? null : String(raw.weight),
    };

    return apiGateway<{
      payload: {
        linkId: string;
        doctorUuid: string;
        patientUuid: string;
      };
    }>({
      method: "POST",
      url: "/clinical-history/doctor-patient-links",
      data: {
        doctorCode: doctor.code,
        patient,
      },
    });
  };

  return useMutation({
    mutationFn: editPatientFn,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["request", requestId],
      });
      navigate(prevRoute);
    },
    onError: (error) => {
      console.error("Error editing patient:", error);
    },
  });
};
